import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar, { scrollToId } from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Despre from "@/components/Despre";
import Profesoara from "@/components/Profesoara";
import Cursuri from "@/components/Cursuri";
import TrialForm from "@/components/TrialForm";
import Program from "@/components/Program";
import Scoli from "@/components/Scoli";
import Social from "@/components/Social";
import Contact from "@/components/Contact";
import ConsentBanner, { usePixelConsent } from "@/components/ConsentBanner";
import PixelRouteTracker from "@/components/PixelRouteTracker";
import ThankYou from "@/pages/ThankYou";

function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Profesoara />
        <Despre />
        <Cursuri />
        <TrialForm />
        <Program />
        <Scoli />
        <Social />
        <Contact />
      </main>
    </>
  );
}

function App() {
  const { consent, choose } = usePixelConsent();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <PixelRouteTracker consent={consent} />
      <div className="App noise-overlay" data-testid="sora-landing-page">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/thank-you-trial" element={<ThankYou title="Cererea pentru lecția gratuită a fost trimisă!" />} />
          <Route path="/thank-you-course" element={<ThankYou title="Înscrierea ta a fost trimisă!" />} />
        </Routes>
        <a
          href="#top"
          data-testid="fixed-seal"
          onClick={(e) => { e.preventDefault(); scrollToId("#top"); }}
          aria-label="Înapoi sus"
          className="fixed bottom-5 right-5 z-30 animate-seal-drift"
        >
          <img src="/sora-logo.png" alt="Sigiliul SORA" className="h-14 w-auto drop-shadow-[0_8px_20px_rgba(211,47,47,0.3)]" />
        </a>
        {consent === "unknown" && <ConsentBanner onChoice={choose} />}
      </div>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
